























































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import BaseComponent from '@/components/BaseComponent';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import GeometryType from '@/models/map-context/GeometryType';
import LayerConfig from '@/models/map-context/LayerConfig';
import TextStyle from '@/models/map-context/style/TextStyle';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    textStyle: TextStyle,
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
  },
})
export default class TexteStyleDefinition extends BaseComponent {
  textStyle!:TextStyle;

  layer!:LayerConfig;

  positionList=['center', 'end', 'left', 'right', 'start'];

  fontList=['Arial','Courier New','Georgia', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'];

  geoserverFonts=["10.15 Saturday Night BRK","10.15 Saturday Night R BRK","18 Holes BRK","36 days ago BRK","36 days ago Thick BRK","3D LET BRK","8-bit Limit BRK","8-bit Limit O BRK","8-bit Limit R BRK","8-bit Limit RO BRK","90 Stars BRK","Acid Reflux BRK","Acknowledge TT BRK","Aftermath BRK","Alpha Beta BRK","Amalgamate BRK","Amalgamate O BRK","Amplitude BRK","Andale Mono","Arial","Arial Black","Arial Bold","Arial Bold Italic","Arial Italic","Arthritis BRK","Aspartame BRK","Ataxia BRK","Ataxia Outline BRK","Automatica BRK","Backlash BRK","Bandwidth BRK","Bandwidth Bandless BRK","Bandwidth Bandmess BRK","Bend 2 Squares BRK","Bend 2 Squares OL1 BRK","Bend 2 Squares OL2 BRK","Bendable BRK","Bewilder BRK","Bewilder Thick BRK","Binary 01s BRK","Binary BRK","Binary CHR BRK","Binary X 01s BRK","Binary X BRK","Binary X CHR BRK","Bit Blocks TTF BRK","Bitstream Vera Sans","Bitstream Vera Sans Bold","Bitstream Vera Sans Bold Oblique","Bitstream Vera Sans Mono","Bitstream Vera Sans Mono Bold","Bitstream Vera Sans Mono Bold Oblique","Bitstream Vera Sans Mono Oblique","Bitstream Vera Sans Oblique","Bitstream Vera Serif","Bitstream Vera Serif Bold","Blackoninaut BRK","Blackoninaut Bold BRK","Blackoninaut Redux BRK","Bleak Segments BRK","Block Tilt BRK","Blox BRK","Bobcaygeon BRK","Bobcaygeon Plain BRK","Bocuma Angle BRK","Bocuma Angle Dent BRK","Bocuma BRK","Bocuma Batty BRK","Bocuma Dent BRK","Brass Knuckle BRK","Brass Knuckle SS BRK","Brass Knuckle Star BRK","Brigadoom BRK","Brigadoom Wide BRK","Bumped BRK","CLAW 1 BRK","CLAW 2 BRK","Candy Stripe BRK","Cantarell","Cantarell Bold","Cantarell Extra Bold","Cantarell Light","Cantarell Regular","Cantarell Thin","Chemical Reaction A BRK","Chemical Reaction B BRK","Chintzy CPU BRK","Chintzy CPU Shadow BRK","Chumbly BRK","Circulate BRK","Classic Trash 1 BRK","Classic Trash 2 BRK","Cleaved TTR BRK","Code Of Life BRK","Collective O BRK","Collective RO BRK","Collective RS BRK","Collective S BRK","Combustion I BRK","Combustion II BRK","Combustion Plain BRK","Combustion Tall BRK","Combustion Wide BRK","Comic Sans MS","Comic Sans MS Bold","Compliant Confuse 1o BRK","Compliant Confuse 1s BRK","Compliant Confuse 2o BRK","Compliant Confuse 2s BRK","Compliant Confuse 3o BRK","Compliant Confuse 3s BRK","Conduit 2 BRK","Conduit 2 Italics BRK","Conduit BRK","Corpulent Caps BRK","Corpulent Caps Shadow BRK","Courier New","Courier New Bold","Courier New Bold Italic","Courier New Italic","Crackdown O1 BRK","Crackdown O2 BRK","Crackdown R BRK","Crackdown R2 BRK","DB Layer 1 BRK","DB Layer 2 BRK","DB Layer 3 BRK","DB Layer 4 BRK","Dark Side BRK","Dash Dot BRK","Dastardly BRK","Decrepit BRK","DejaVu Sans","DejaVu Sans Bold","DejaVu Sans Mono","DejaVu Sans Mono Bold","DejaVu Serif","DejaVu Serif Bold","Delphine","Dented BRK","Dephunked BRK","Detonate BRK","Dialog","Dialog.bold","Dialog.bolditalic","Dialog.italic","Dialog.plain","DialogInput","DialogInput.bold","DialogInput.bolditalic","DialogInput.italic","DialogInput.plain","Discordance BRK","Double Bogey BRK","Draggle BRK","Draggle over kerned BRK","Dynamic BRK","Dyphusion BRK","Dystorque BRK","Ecliptic BRK","Edit Undo BRK","Edit Undo Dot BRK","Edit Undo Line BRK","Elsewhere 2 BRK","Elsewhere BRK","Embossing Tape 1 BRK","Embossing Tape 2 BRK","Embossing Tape 3 BRK","Encapsulate BRK","Encapsulate Plain BRK","Entangled BRK","Entangled Layer A BRK","Entangled Layer B BRK","Entangled Plain BRK","Enthuse BRK","Enthuse Solid BRK","Euphoric 3D BRK","Euphoric BRK","Exaggerate BRK","Extraction BRK","False Positive BRK","False Positive Round BRK","Fascii BRK","Fascii Cross BRK","Fascii Scraggly BRK","Fascii Smudge BRK","Fascii Twigs BRK","Fatboy Slim BLTC 2 BRK","Fatboy Slim BLTC BRK","Faux Snow BRK","Fidgety BRK","Flipside BRK","Forcible BRK","Foreshadow BRK","Foreshadow OL BRK","Freak Turbulence BRK","Frizzed BRK","Fully Completely BRK","Galapogos BRK","Galvanize BRK","Gaposis Outline BRK","Gaposis Solid BRK","Gasping BRK","Gather BRK","Gather Gapped BRK","Georgia","Georgia Bold","Georgia Bold Italic","Georgia Italic","Gesture BRK","Gesture Slant BRK","Gesture Thin BRK","Gesture Thin Slant BRK","Goose Bumps BRK","Goose Bumps II BRK","Granular BRK","Grapple BRK","Graveyard BRK","Gravitate BRK","Gravitate Segments BRK","Graze BRK","Great Heights BRK","Grotesque BRK","Grudge 2 BRK","Grudge BRK","Gyneric 3D BRK","Gyneric BRK","Gyrose BRK","Gyrose Shift BRK","Gyrose Squeeze BRK","Hack & Slash BRK","Hairball BRK","Hand Me Down O BRK","Hand Me Down S BRK","Hassle BRK","Head-Ding Maker BRK","Hearts BRK","Heavy Bevel BRK","Hillock BRK","Homespun TT BRK","Hyde BRK","Hyperion Sunset BRK","Impact","Impossibilium BRK","Inertia BRK","Inevitable BRK","Ink Swipes BRK","Ink Tank BRK","Intersect BRK","Intersect C BRK","Intersect O BRK","Irritate BRK","It Lives In The Swamp BRK","Jagged BRK","Janken BRK","Jargon BRK","Jasper BRK","Jasper Solid BRK","Jawbreaker BRK","Jawbreaker Hard BRK","Jawbreaker OL1 BRK","Jawbreaker OL2 BRK","Jekyll BRK","Jeopardize BRK","Jeopardize Thick BRK","Johnny Mac Scrawl BRK","Jolt Of Caffeine BRK","Jupiter Crash BRK","Kaliber Round BRK","Kaliber Solid BRK","Kaliber Xtreme BRK","Katalyst active BRK","Katalyst inactive BRK","Key Ridge BRK","Key Ridge alt BRK","Kickflip BRK","Kinkaid BRK","Kirby No Kira Kizzu BRK","Knot BRK","Konector BRK","Konector Eerie BRK","Konector O1 BRK","Konector O2 BRK","Kurvature BRK","LM Mono 10","LM Mono 12","LM Mono 8","LM Mono 9","LM Mono Caps 10","LM Mono Light 10","LM Mono Light Cond 10","LM Mono Prop 10","LM Mono Prop Light 10","LM Mono Slanted 10","LM Roman 10","LM Roman 12","LM Roman 17","LM Roman 5","LM Roman 6","LM Roman 7","LM Roman 8","LM Roman 9","LM Roman Caps 10","LM Roman Demi 10","LM Roman Dunhill 10","LM Roman Slanted 10","LM Roman Slanted 12","LM Roman Slanted 17","LM Roman Slanted 8","LM Roman Slanted 9","LM Roman Unslanted 10","LM Sans 10","LM Sans 12","LM Sans 17","LM Sans 8","LM Sans 9","LM Sans Demi Cond 10","LM Sans Quot 8","LMMono10-Italic","LMMono10-Regular","LMMono12-Regular","LMMono8-Regular","LMMono9-Regular","LMMonoCaps10-Oblique","LMMonoCaps10-Regular","LMMonoLt10-Bold","LMMonoLt10-BoldOblique","LMMonoLt10-Oblique","LMMonoLt10-Regular","LMMonoLtCond10-Oblique","LMMonoLtCond10-Regular","LMMonoProp10-Oblique","LMMonoProp10-Regular","LMMonoPropLt10-Bold","LMMonoPropLt10-BoldOblique","LMMonoPropLt10-Oblique","LMMonoPropLt10-Regular","LMMonoSlant10-Regular","LMRoman10-Bold","LMRoman10-BoldItalic","LMRoman10-Italic","LMRoman10-Regular","LMRoman12-Bold","LMRoman12-Italic","LMRoman12-Regular","LMRoman17-Regular","LMRoman5-Bold","LMRoman5-Regular","LMRoman6-Bold","LMRoman6-Regular","LMRoman7-Bold","LMRoman7-Italic","LMRoman7-Regular","LMRoman8-Bold","LMRoman8-Italic","LMRoman8-Regular","LMRoman9-Bold","LMRoman9-Italic","LMRoman9-Regular","LMRomanCaps10-Oblique","LMRomanCaps10-Regular","LMRomanDemi10-Oblique","LMRomanDemi10-Regular","LMRomanDunh10-Oblique","LMRomanDunh10-Regular","LMRomanSlant10-Bold","LMRomanSlant10-Regular","LMRomanSlant12-Regular","LMRomanSlant17-Regular","LMRomanSlant8-Regular","LMRomanSlant9-Regular","LMRomanUnsl10-Regular","LMSans10-Bold","LMSans10-BoldOblique","LMSans10-Oblique","LMSans10-Regular","LMSans12-Oblique","LMSans12-Regular","LMSans17-Oblique","LMSans17-Regular","LMSans8-Oblique","LMSans8-Regular","LMSans9-Oblique","LMSans9-Regular","LMSansDemiCond10-Oblique","LMSansDemiCond10-Regular","LMSansQuot8-Bold","LMSansQuot8-BoldOblique","LMSansQuot8-Oblique","LMSansQuot8-Regular","LYNX BRK","Lakeshore BRK","Lamebrain BRK","Larkspur BRK","Latin Modern Math","LatinModernMath-Regular","Lethargic BRK","Licorice Strings BRK","Lights Out BRK","Line Dings BRK","Loopy BRK","Lowdown BRK","Lucid Type A BRK","Lucid Type A Outline BRK","Lucid Type B BRK","Lucid Type B Outline BRK","Lyneous BRK","Lyneous Linear BRK","Macropsia BRK","Mad's Scrawl BRK","Mincer BRK","Mini Kaliber O TT BRK","Mini Kaliber S TT BRK","Mishmash 4x4i BRK","Mishmash 4x4o BRK","Mishmash ALT1 BRK","Mishmash ALT2 BRK","Mishmash BRK","Mishmash Fuse BRK","Mobilize BRK","Monkey Phonics BRK","Monospaced","Monospaced.bold","Monospaced.bolditalic","Monospaced.italic","Monospaced.plain","Moronic Misfire BRK","Mysterons BRK","Nanosecond Thick BRK","Nanosecond Thin BRK","Nanosecond Wide BRK","Naughts BRK","Neural BRK","Neural Outline BRK","Nominal BRK","Nostalgia BRK","Not Quite Right BRK","Nucleus BRK","Numskull BRK","Nymonak BRK","Obloquy Outline BRK","Obloquy Solid BRK","Obstacle BRK","Obstacle Lines BRK","Off Kilter L BRK","Off Kilter R BRK","Opiated BRK","Orbicular BRK","Outer Sider BRK","Overhead BRK","Perfect Dark BRK","Persuasion BRK","Phorfeit Regular BRK","Phorfeit Slant BRK","Pincers BRK","Pindown BRK","Pindown Plain BRK","Pindown X BRK","Pindown X Plain BRK","Pixel Krud BRK","Plasma Drip BRK","Plasma Drip Empty BRK","Pneumatics BRK","Pneumatics Tall BRK","Pneumatics Wide BRK","Powderworks BRK","Pseudo BRK","Qbicle 1 BRK","Qbicle 2 BRK","Qbicle 3 BRK","Qbicle 4 BRK","Qlumpy BRK","Qlumpy Shadow BRK","Quacksalver BRK","Quadratic BRK","Quadratic Cal BRK","Quandary BRK","Quantum Flat BRK","Quantum Flat Hollow BRK","Quantum Round BRK","Quantum Round Hollow BRK","Quantum Taper BRK","Quarantine BRK","Quarterly Thick BRK","Quarterly Thin BRK","Queasy BRK","Queasy Outline BRK","Quill Experimental O BRK","Quill Experimental S BRK","Rambling BRK","Ravaged By Years BRK","Ravenous Caterpillar BRK","Raydiate BRK","Reason BRK","Reason Shadow BRK","Redundant BRK","Regenerate BRK","Registry BRK","Rehearsal Curve BRK","Rehearsal Offset BRK","Rehearsal Point BRK","Relapse BRK","Revert BRK","Revert Round BRK","Rotund BRK","Rotund Outline BRK","Rough Day BRK","Ryuker BRK","SansSerif","SansSerif.bold","SansSerif.bolditalic","SansSerif.italic","SansSerif.plain","Sarcastic BRK","Saunder BRK","Scalelines BRK","Scalelines Maze BRK","Sequence BRK","Serif","Serif.bold","Serif.bolditalic","Serif.italic","Serif.plain","Setback TT BRK","Sideways BRK","Simpleton BRK","Skull Capz BRK","Slender BRK","Slender Mini BRK",
  "Slender Stubby BRK","Slender Wide BRK","Snailets BRK","Spacious BRK","Spacious Outline BRK","Spastic BRK","Spheroids BRK","Spheroids X BRK","Splatz BRK","Square Route BRK","Stagnation BRK","Steve","SteveHand","Stranded BRK","Supra Genius Curves BRK","Supra Genius Lines BRK","Swirled BRK","Symmetry BRK","Syndrome BRK","Synthetic BRK","Syracuse BRK","TRAGIC BRK","Tearful BRK","Technique BRK","Technique OL BRK","Telephasic BRK","Tetricide BRK","Thwart BRK","Times New Roman","Times New Roman Bold","Times New Roman Bold Italic","Times New Roman Italic","Tonik BRK","Trebuchet MS","Trebuchet MS Bold","Trebuchet MS Bold Italic","Trebuchet MS Italic","Turmoil BRK","Typesource Extol O BRK","Typesource Extol S BRK","UNITED BRK","Ubiquity BRK","Unanimous BRK","Unanimous Inverted BRK","Underscore 2 BRK","Underscore BRK","Underwhelmed BRK","Underwhelmed Outline BRK","Unexplored Galaxies BRK","Unexplored Galaxies O BRK","Unexplored Galaxies W BRK","Unexplored Galaxies WO BRK","Unlearned 2 BRK","Unlearned BRK","Unresponsive BRK","Upheaval TT BRK","Upraise BRK","Vacant Capz BRK","Vanished BRK","Vantage BRK","Variance BRK","Verdana","Verdana Bold","Verdana Bold Italic","Verdana Italic","Vertigo 2 BRK","Vertigo BRK","Vertigo Upright 2 BRK","Vertigo Upright BRK","Vigilance BRK","Vindictive BRK","Visitor TT1 BRK","Visitor TT2 BRK","Volatile 1 BRK","Volatile 2 BRK","Wager BRK","Wager Lost BRK","Wager Won BRK","Wayward BRK","Wayward Shadow BRK","Weathered BRK","Weathered Solid BRK","Weaver BRK","Webdings","Whatever BRK","Whippersnapper BRK","Wiggly Squiggly BRK","Wincing BRK","Withstand BRK","Wobbly BRK","Wyvern Wings BRK","Wyvern Wings Wyde BRK","Xerox Malfunction BRK","Xhume BRK","Xipital BRK","Xmas Lights BRK","Xtrusion BRK","Yearend BRK","Yesterday BRK","Yielding BRK","Yonder BRK","Yoshi's Story game text BRK","Your Complex BRK","Your Complex I BRK","Your Complex O BRK","Zelda DX TT BRK","Zenith BRK","Zephyrean BRK","Zephyrean Gust BRK","Zero Velocity BRK","Zirconia BRK","Zirconia Cubic BRK","Zoetrope BRK","Zoidal BRK","Zurklez Outline BRK","Zurklez Solid BRK","genotype H BRK","genotype RH BRK","genotype RS BRK","genotype S BRK","techno overload BRK","waver BRK","Æ Systematic TT BRK","Ænigma Scrawl 4 BRK"];
  
  vectorFonts=['Arial','Courier New','Georgia', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'];
 
 mounted(){
    this.checkGeom();
    this.updateFontList();
  }
  
  @Watch('layer.geometryType')
  onChangeType(event: any){
    this.checkGeom();
    this.updateFontList();
  }

  @Watch('layer.type')
  onChangeLayerType(event: any){
    this.updateFontList();
  }

  onTexteFocus(event: any){
  console.log("onTexteFocus");
   if(this.textStyle.text=="" && this.textStyle.baseStyle.text.length>0){
      this.textStyle.text=this.textStyle.baseStyle.text;
   }
  }

  onTexteBlur(event: any){
  console.log("onTexteFocus");
   if(this.textStyle.text==this.textStyle.baseStyle.text && this.textStyle.baseStyle.text.length>0){
      this.textStyle.text='';
   }
  }

  updateFontList(){
    if(!this.layer.isVectorRenderLayer()){
      this.fontList=this.geoserverFonts;
      if(this.contextService.configuration.geoserver_extra_fonts && this.contextService.configuration.geoserver_extra_fonts.length>0){
        this.fontList=this.geoserverFonts.concat(this.contextService.configuration.geoserver_extra_fonts).sort();
      }
    }
    else{
      this.fontList=this.vectorFonts;
    }
  }
  checkGeom(){
    // Pour les lignes on précise que c'est une ligne dans le style
    // pour le placement du label
    if(this.layer.geometryType == GeometryType.LINE){
      this.textStyle.lineGeom= true;
    }
    else{
      this.textStyle.lineGeom= false;
    }
    if(this.layer.geometryType == GeometryType.POLYGON){
      this.textStyle.useCentroid= true;
      this.textStyle.geomAttributeName=this.layer.getGeomAttributeName();
    }
    else{
      this.textStyle.useCentroid= false;
    }
  }
  addField(field:any) {
    this.textStyle.text += `{${field.name}}`;
  }

  addFieldToZoffset(field:any) {
    this.textStyle.offsetZ = `{${field.name}}`;
  }

  get showFollowLine():boolean {
    return this.layer.geometryTypeNotDefined()
    || this.layer.geometryType == GeometryType.LINE;
  }
}
